// src/components/Analytics/GoogleAnalytics.js
// Componente para inicializar GA4 en la app

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA4, trackPageView } from '../../helpers/analytics';

/**
 * GoogleAnalytics Component
 * 
 * Inicializa GA4 y trackea cambios de página automáticamente
 * 
 * Uso en App.js:
 * import GoogleAnalytics from './components/Analytics/GoogleAnalytics';
 * 
 * <GoogleAnalytics measurementId="G-XXXXXXXXXX" />
 */

const GoogleAnalytics = ({ measurementId }) => {
  const location = useLocation();

  // Inicializar GA4 al montar
  useEffect(() => {
    if (measurementId && process.env.NODE_ENV === 'production') {
      initGA4(measurementId);
    } else {
      console.log('📊 Analytics disabled in development');
    }
  }, [measurementId]);

  // Track page views en cada cambio de ruta
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);

  return null; // No renderiza nada
};

export default GoogleAnalytics;
